import { GUEST_FILTER } from '@entities/participants';
import InputSearch from '@shared/ui/input-search';
import { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { Button } from '@shared/ui/kit';
import { styles } from './styles';

interface FilterParticipantsProps {
  handleSearchChange: (search: string) => void;
  handleGuestFilterChange: (value: string | null) => void;
}

export const FilterParticipants = ({ handleGuestFilterChange, handleSearchChange }: FilterParticipantsProps) => {
  const [guestFilter, setGuestFilter] = useState<string | null>(null);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSearchChange(searchValue);
      handleGuestFilterChange(guestFilter);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchValue, handleGuestFilterChange, handleSearchChange, guestFilter]);

  return (
    <div {...stylex.props(styles.filterContainer)}>
      <span {...stylex.props(styles.filterTitle)}>Фильтры</span>

      <div {...stylex.props(styles.filter)}>
        <InputSearch searchValue={searchValue} changeValue={setSearchValue} clearHandler={() => setSearchValue('')} />

        <div {...stylex.props(styles.filterParticipantsContainer)}>
          <span {...stylex.props(styles.filterParticipantsTitle)}>Участники</span>

          <div {...stylex.props(styles.filterParticipants)}>
            <Button size="small" variant={guestFilter ? 'link' : 'primary'} onClick={() => setGuestFilter(null)}>
              Любой
            </Button>

            <Button
              size="small"
              variant={guestFilter === GUEST_FILTER.NOT_ALONE ? 'primary' : 'link'}
              onClick={() => setGuestFilter(GUEST_FILTER.NOT_ALONE)}
            >
              Не один
            </Button>

            <Button
              size="small"
              variant={guestFilter === GUEST_FILTER.WITH_CHILDREN ? 'primary' : 'link'}
              onClick={() => setGuestFilter(GUEST_FILTER.WITH_CHILDREN)}
            >
              С детьми
            </Button>

            <Button
              size="small"
              variant={guestFilter === GUEST_FILTER.WITHOUT_CHILDREN ? 'primary' : 'link'}
              onClick={() => setGuestFilter(GUEST_FILTER.WITHOUT_CHILDREN)}
            >
              Без детей
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
